import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const TrendingUpIcon = ({
  title = 'TrendingUp',
  className = 'trending-up-icon',
  color = 'currentColor',
  viewBox = '0 0 14 14',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} className={className} viewBox={viewBox} {...props} fill="none">
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m1.75 9.917 3.5-3.5L7.583 8.75l4.667-4.667"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.167 4.083h4.083v4.084"
    />
  </CreateIconComponent>
);

export default TrendingUpIcon;
